import { css } from '@emotion/css';

import { LARGE_DEVICE_MQ } from 'apps/shared/scripts/styles/constants';

export const buttonMobileClassName = css({
  display: 'block',
  [LARGE_DEVICE_MQ]: {
    display: 'none',
  }
});
